<app-breadcrumb  [master]="'Narzędzia'" [parentName]="'Baza wiedzy'" [name]="'Tagi'"></app-breadcrumb>
<div class="tag-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="tags-list-filters">
    <mat-form-field class="tags-list-filter">
      <mat-label>Nazwa tagu</mat-label>
      <input matInput placeholder="Plik.pdf" name="name" [(ngModel)]="initialFilters.name">
    </mat-form-field>

    <mat-form-field appearance="standard" class="tags-list-filter">
      <mat-label>Aktywne</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-datepicker
      class="tags-list-filter"
      label="Data dodania od"
      placeholder="2000-01-01"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="tags-list-filter"
      label="Data dodania do"
      placeholder="2000-01-01"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field class="tags-list-filters">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

  </form>

  <div class="tags-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  <div >
    <div class="add-button">
        <button  (click)="add()"  mat-raised-button color="accent" [disabled]="!(userPermissions | async).file_manager.create">
          <mat-icon>add</mat-icon> <span> Dodaj</span>
        </button>
    </div>


  </div>

  <table mat-table [dataSource]="tags" multiTemplateDataRows  >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef >  Nazwa tagu</th>
      <td mat-cell *matCellDef="let element">
       {{element.name}}
      </td>
    </ng-container>


    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef  > Aktywny</th>
      <td mat-cell *matCellDef="let element" >
        {{ element.active ? 'TAK' : 'NIE' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createAt">
      <th mat-header-cell *matHeaderCellDef > Data dodania</th>
      <td mat-cell *matCellDef="let element" >
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef > Użytkownik</th>
      <td mat-cell *matCellDef="let element" >
        {{element.createdBy }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef > </th>
      <td mat-cell *matCellDef="let element" >
        <button  mat-icon-button
                 [disabled]="!(userPermissions | async).file_manager.write"
                (click)="mod(element)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
